import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  subDays,
  subWeeks,
  subMonths,
  subQuarters,
  startOfQuarter,
  endOfQuarter,
  format
} from 'date-fns';

/**
 * Retorna um objeto com dateBegin e dateEnd de acordo com o período selecionado.
 * @param {string} period - Opção selecionada.
 * @param {object} [customRange] - Caso seja 'dateRange', deve conter { dateBegin, dateEnd }.
 * @returns {{ dateBegin: string, dateEnd: string }}
 */
export function getPeriodDates(period, customRange = {}) {
  const today = new Date();
  const formatDate = (date) => format(date, 'dd/MM/yyyy');
  switch (period) {
    case 'today':
      return {
        dateBegin: formatDate(today),
        dateEnd: formatDate(today)
      };
    case 'yesterday': {
      const yest = subDays(today, 1);
      return {
        dateBegin: formatDate(yest),
        dateEnd: formatDate(yest)
      };
    }
    case 'last7Days': {
      const start = subDays(today, 6);
      return {
        dateBegin: formatDate(start),
        dateEnd: formatDate(today)
      };
    }
    case 'thisWeek': {
      const weekStart = startOfWeek(today, { weekStartsOn: 1 });
      const weekEnd = endOfWeek(today, { weekStartsOn: 1 });
      return {
        dateBegin: formatDate(weekStart),
        dateEnd: formatDate(weekEnd)
      };
    }
    case 'lastWeek': {
      const lastWeekStart = startOfWeek(subWeeks(today, 1), {
        weekStartsOn: 1
      });
      const lastWeekEnd = endOfWeek(subWeeks(today, 1), { weekStartsOn: 1 });
      return {
        dateBegin: formatDate(lastWeekStart),
        dateEnd: formatDate(lastWeekEnd)
      };
    }
    case 'thisMonth': {
      const monthStart = startOfMonth(today);
      const monthEnd = endOfMonth(today);
      return {
        dateBegin: formatDate(monthStart),
        dateEnd: formatDate(monthEnd)
      };
    }
    case 'lastMonth': {
      const lastMonthDate = subMonths(today, 1);
      const lastMonthStart = startOfMonth(lastMonthDate);
      const lastMonthEnd = endOfMonth(lastMonthDate);
      return {
        dateBegin: formatDate(lastMonthStart),
        dateEnd: formatDate(lastMonthEnd)
      };
    }
    case 'thisYear': {
      const yearStart = startOfYear(today);
      const yearEnd = endOfYear(today);
      return {
        dateBegin: formatDate(yearStart),
        dateEnd: formatDate(yearEnd)
      };
    }
    case 'lastYear': {
      const lastYearDate = subMonths(today, 12);
      const yearStart = startOfYear(lastYearDate);
      const yearEnd = endOfYear(lastYearDate);
      return {
        dateBegin: formatDate(yearStart),
        dateEnd: formatDate(yearEnd)
      };
    }
    case 'thisQuarter': {
      const quarterStart = startOfQuarter(today);
      const quarterEnd = endOfQuarter(today);
      return {
        dateBegin: formatDate(quarterStart),
        dateEnd: formatDate(quarterEnd)
      };
    }
    case 'lastQuarter': {
      const lastQuarterDate = subQuarters(today, 1);
      const quarterStart = startOfQuarter(lastQuarterDate);
      const quarterEnd = endOfQuarter(lastQuarterDate);
      return {
        dateBegin: formatDate(quarterStart),
        dateEnd: formatDate(quarterEnd)
      };
    }
    case 'dateRange':
      return {
        dateBegin: customRange.dateBegin,
        dateEnd: customRange.dateEnd
      };
    default:
      return { dateBegin: '', dateEnd: '' };
  }
}
